import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import ExternalLinkIcon from './ExternalLinkIcon.vue';
import HeartIcon from './HeartIcon.vue';
import CirclePlusIcon from './CirclePlusIcon.vue';
import UserIcon from './UserIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DynamicIcon',
    props: {
        name: {},
        background: { default: 'none' },
        color: { default: 'white' }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.name === 'externalLink')
                    ? (_openBlock(), _createBlock(ExternalLinkIcon, {
                        key: 0,
                        color: _ctx.color,
                        background: _ctx.background
                    }, null, 8, ["color", "background"]))
                    : _createCommentVNode("", true),
                (_ctx.name === 'heart')
                    ? (_openBlock(), _createBlock(HeartIcon, {
                        key: 1,
                        color: _ctx.color,
                        background: _ctx.background
                    }, null, 8, ["color", "background"]))
                    : _createCommentVNode("", true),
                (_ctx.name === 'circlePlus')
                    ? (_openBlock(), _createBlock(CirclePlusIcon, {
                        key: 2,
                        color: _ctx.color,
                        background: _ctx.background
                    }, null, 8, ["color", "background"]))
                    : _createCommentVNode("", true),
                (_ctx.name === 'user')
                    ? (_openBlock(), _createBlock(UserIcon, {
                        key: 3,
                        color: _ctx.color,
                        background: _ctx.background
                    }, null, 8, ["color", "background"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
